var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"id_13",class:{ 'embedded': _vm.embedded }},[_c('ContentInsertion',{ref:"contentInsertion",attrs:{"features":_vm.insertFeatures},on:{"insert-image":_vm.handleImageInsert,"insert-columns":_vm.handleColumnsInsert,"insert-table":_vm.handleTableInsert,"insert-file":_vm.handleFileInsert}}),_vm._v(" "),_c('div',{staticClass:"highlight-box",style:({
      background: _vm.data.bgColor || '#FFF3CD',
      borderColor: _vm.data.borderColor || '#FFC107',
      minHeight: _vm.contentHeight + 'px'
    })},[_c('div',{ref:"contentRef",staticClass:"highlight-content"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4e78b0ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/id_13.vue
// module id = null
// module chunks = 